import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Bharatanatyam", "Kuchipudi", "Hip Hop", "Bollywood", "Freestyle",
  "Folk", "Semi Classical", "Western", "Kids Dance", "Classical",
];

export default function EditorialMarquee() {
  return (
    <section className="bg-purple py-8 md:py-10 border-y border-[rgba(212,175,55,0.2)] overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-10 md:mx-16 inline-flex items-center gap-10 md:gap-16">
            <span className="font-serif text-4xl md:text-6xl font-light text-[#F6F4EE]/90">{t}</span>
            <span className="text-gold text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
